import React, { Component } from 'react'
import { Form, Modal, DatePicker, Select, Table, Icon, Popconfirm } from 'antd'
import PropTypes from 'prop-types'

const FormItem = Form.Item
const Option = Select.Option

const propTypes = {
  modalOpened: PropTypes.bool.isRequired,
  selectedOpenItems: PropTypes.array,
  vehicles: PropTypes.array,
  drivers: PropTypes.array,
  toggleModal: PropTypes.func.isRequired,
  removeSelectedOpenItems: PropTypes.func.isRequired,
  addScheduledDelivery: PropTypes.func.isRequired
}

class ScheduleModal extends Component {
  vehiclesOptions = () => {
    const { vehicles } = this.props
    if (vehicles) {
      return vehicles.map(vehicle => <Option key={vehicle.id}>{vehicle.name}</Option>)
    }
  }

  driversOptions = () => {
    const { drivers } = this.props
    if (drivers) {
      return drivers.map(driver => (
        <Option key={driver.id}>
          {driver.first_name} {driver.last_name}
        </Option>
      ))
    }
  }

  getColumns = () => {
    const { removeSelectedOpenItems } = this.props
    return [
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'tyoe'
      },
      {
        title: 'Number',
        dataIndex: 'number',
        key: 'number'
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name',
        key: 'job_name'
      },
      {
        title: 'Job Address',
        dataIndex: 'job_address',
        key: 'job_address'
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
      },
      {
        title: 'Actions',
        key: 'action',
        render: a => {
          return (
            <div>
              <Popconfirm title="Sure to delete?" onConfirm={() => removeSelectedOpenItems(a.key)}>
                <Icon type="close" />
              </Popconfirm>
            </div>
          )
        }
      }
    ]
  }

  getDataSource = () => {
    const { selectedOpenItems } = this.props
    if (selectedOpenItems) {
      return selectedOpenItems.map(openItem => ({
        key: openItem.id,
        type: openItem.type,
        number: openItem.number,
        job_name: openItem.job_name,
        job_address: '',
        description: openItem.description
      }))
    } else {
      return []
    }
  }

  handleAddScheduledDelivery = () => {
    const { addScheduledDelivery, form } = this.props
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      addScheduledDelivery(values)
      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { modalOpened, toggleModal } = this.props
    return (
      <Modal
        visible={modalOpened}
        title="Schedule Delivery"
        okText={'Save Changes'}
        onCancel={toggleModal}
        onOk={this.handleAddScheduledDelivery}
        width={'95%'}
        maskClosable={false}
      >
        <Form layout="vertical">
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Scheduled Date">
                {getFieldDecorator('scheduled_date', {
                  rules: [
                    {
                      required: true,
                      message: 'Scheduled Date cannot be blank.'
                    }
                  ]
                })(<DatePicker />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <FormItem label="Vehicle">
                {getFieldDecorator('vehicle', {
                  rules: [
                    {
                      required: true,
                      message: 'Vehicle cannot be blank.'
                    }
                  ]
                })(
                  <Select
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.vehiclesOptions()}
                  </Select>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <FormItem label="Drivers">
                {getFieldDecorator('driver', {
                  rules: [
                    {
                      required: true,
                      message: 'Driver cannot be blank.'
                    }
                  ]
                })(
                  <Select
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.driversOptions()}
                  </Select>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h6>Open Requests to Schedule</h6>
              <Table dataSource={this.getDataSource()} columns={this.getColumns()} />
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

ScheduleModal.propTypes = propTypes

export default Form.create()(ScheduleModal)



// WEBPACK FOOTER //
// ./src/components/drivers/scheduledDeliveries/ScheduleModal.js